module.exports = __webpack_public_path__ + "img/sphone_feature_knowledge.e016f8be.png";